import {FC, useMemo} from 'react'
import Highcharts from 'highcharts/es-modules/masters/highcharts.src'
import HighchartsReact from 'highcharts-react-official'
import {CGESectorOutput} from '../core/_models'
import {divergingColor} from './chartColors'

type CGESectorImpactChartProps = {
  focusName: string
  sectors: CGESectorOutput[]
}

const CGESectorImpactChart: FC<CGESectorImpactChartProps> = ({focusName, sectors}) => {
  const options = useMemo(
    () => ({
      chart: {type: 'bar', height: 380, backgroundColor: 'transparent'},
      title: {text: ''},
      xAxis: {categories: sectors.map((s) => s.name), labels: {style: {fontSize: '0.8rem'}}},
      yAxis: {title: {text: `${focusName} sector output change (%)`}},
      legend: {enabled: false},
      credits: {enabled: false},
      tooltip: {
        pointFormatter: function (this: any) {
          return `Output change: <b>${this.y}%</b>`
        },
      },
      plotOptions: {
        bar: {
          borderWidth: 0,
          dataLabels: {enabled: true, format: '{y}%'},
        },
      },
      series: [
        {
          name: 'Sector output change',
          data: sectors.map((s) => ({y: s.output_pct, color: divergingColor(s.output_pct)})),
        },
      ],
    }),
    [focusName, sectors]
  )

  return <HighchartsReact highcharts={Highcharts} options={options} />
}

export {CGESectorImpactChart}
